import _ from 'underscore';
import {
  fwdLinkIdMapping,
  editorialErrorCodeToErrorMessageMapping,
  isLinkedInEditorialError,
  LandingUrlMapping,
} from './error-mapping';

const defaultFwdLinkId = 534338;

export function logTrace(activityLogger, message) {
  if (activityLogger && activityLogger.trace) {
    activityLogger.trace(message);
  }
}

export function getFwdLinkId(code, distLcid, activityLogger) {
  let flag = code;

  if (!_.isUndefined(distLcid) && !_.isNull(distLcid)) {
    flag = `${flag}_${distLcid}`;
  }

  let mappedFlag = fwdLinkIdMapping[flag];

  if (!mappedFlag) {
    logTrace(activityLogger, `Missed Editorial FwdLink mapping for code: ${flag}, use default`);
    mappedFlag = defaultFwdLinkId;
  }
  return mappedFlag;
}

export function getEditorialErrorMessage(editorialCode, i18n, activityLogger, permissions) {
  const fwLinkId = getFwdLinkId(editorialCode, undefined, activityLogger);
  const i18nKey = `Error_Editorial_Raw_${editorialCode}`;
  const errorMessage = editorialErrorCodeToErrorMessageMapping[i18nKey];

  let message = errorMessage && i18n.getString(errorMessage);

  if (!message) {
    logTrace(activityLogger, `Missed Editorial message mapping for code: ${editorialCode}, use default`);
    message = editorialCode;
  }

  const isLinkedInEditorial = isLinkedInEditorialError(editorialCode);

  let fwlink = `http://go.microsoft.com/fwlink?LinkId=${fwLinkId}`;

  if (permissions && permissions.IsDomesticSimplifiedChineseEnabled) {
    fwlink = 'https://about.ads.microsoft.com/zh-cn/pilotpolicy.pdf';
  }

  const target = isLinkedInEditorial ? '_blank' : '_apexPlatformHelp';
  const link = _.has(LandingUrlMapping, editorialCode) ? LandingUrlMapping[editorialCode] : fwlink;

  return `<a href="${link}" target="${target}">${message}</a>`;
}
